module.exports = __webpack_public_path__ + "static/media/601Hou@4x.18e7f9a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/601Hou@4x.png
// module id = 1678
// module chunks = 0 1